/** Overlay iframe fade; kept in sync with dialog enter for crossfade. */
export const GACHA_REVEAL_FADE_MS = 520
export const GACHA_DIALOG_FADE_MS = 520

/** Result dialog sits above reveal overlay (`z-[200]`). */
export const GACHA_RESULT_DIALOG_OVERLAY_Z = "z-[200]"
export const GACHA_RESULT_DIALOG_CONTENT_Z = "z-[210]"
